import { ChangeDetectionStrategy, ChangeDetectorRef, Component, input, OnInit, AfterViewInit } from '@angular/core';

import { IContactEvent } from '../../../../models/client';
import { ClientService } from '../../../../services/client-service';
import { FormTypeTableColumns, TableColumn } from '../../../../services/common-service';
import { DatatableComponent } from '../../../../utils/datatable-component/datatable-component';

@Component( {
  selector: 'app-contact-events-component',
  imports: [
    DatatableComponent,
  ],
  templateUrl: './contact-events-component.html',
  styleUrl: './contact-events-component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
} )
export class ContactEventsComponent implements OnInit, AfterViewInit
{

  constructor(
    private _cdr: ChangeDetectorRef,
    private _clientService: ClientService,
  )
  {    
  }

  clientId = input.required<string>();
  contactEvents: IContactEvent[] | undefined;
  contactEventColumns: TableColumn[] = [];

  async ngOnInit(): Promise<void>
  {

    this.contactEvents = await this._clientService.getContactEvents( this.clientId() ) || [];   
    this.contactEventColumns = FormTypeTableColumns['Contact'].DefaultColumns.filter( c => !!c.field ) || [];
    this._cdr.detectChanges();
   
  }

  ngAfterViewInit(): void
  {
    this._cdr.detectChanges();
  }



}
